module.exports = __webpack_public_path__ + "static/bandfoto-christian-ea4cbd23648fe71b37fc5f281186bfb3.png";